/**
 * Module dependencies.
 */

import { useTranslation } from 'next-i18next';
import FooterLogo from 'src/assets/landingpage/footer-logo.svg';
import styled from 'styled-components';

/**
 * `Container` styled component.
 */

const Container = styled.div`
  background: #0a0a28;
  flex-shrink: 0;
  position: relative;
  width: 100%;

  > div:first-child {
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 100%;
    margin-inline: auto;
    max-width: 1440px;
    width: 100%;

    > div {
      align-items: center;
      box-sizing: border-box;
      content: stretch;
      display: flex;
      justify-content: space-between;
      padding: 31px 72px;
      position: relative;
      width: 100%;

      @media (max-width: 1280px) {
        padding: 31px 32px;
      }

      @media (max-width: 1024px) {
        align-items: center;
        flex-direction: column;
        gap: 24px;
        padding: 40px 32px;
      }

      @media (max-width: 767px) {
        gap: 16px;
      }
    }
  }

  .logo {
    flex-shrink: 0;
    height: 58.313px;
    position: relative;
    width: 183.909px;

    @media (max-width: 1280px) {
      height: 46.65px;
      width: 147.127px;

      .clip-path .group {
        mask-size: 147.127px 45.978px;
      }
    }

    .clip-path {
      bottom: 0.72%;
      display: contents;
      left: 0;
      position: absolute;
      right: 0;
      top: 0.72%;

      .group {
        bottom: 0.72%;
        left: 0;
        mask-clip: no-clip;
        mask-composite: source-in;
        mask-composite: intersect;
        mask-mode: alpha;
        mask-position: 0;
        mask-repeat: no-repeat;
        mask-size: 183.909px 57.472px;
        position: absolute;
        right: 0;
        top: 0.72%;

        svg {
          display: block;
          height: 100%;
          width: 100%;
        }
      }
    }
  }

  /* Footer links */
  nav {
    align-items: flex-start;
    color: #f1f5f8;
    content: stretch;
    display: flex;
    flex-shrink: 0;
    font-family: Raleway, sans-serif;
    font-size: 12px;
    font-weight: 500;
    gap: 32px;
    line-height: 18px;
    position: relative;
    text-wrap: nowrap;
    white-space: pre;

    @media (max-width: 1024px) {
      align-items: center;
      gap: 24px;
      text-align: center;
    }

    @media (max-width: 767px) {
      flex-direction: column;
      gap: 16px;
    }

    a {
      flex-shrink: 0;
      position: relative;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  /* Copyright text */
  > div > div > p {
    color: #00cddc;
    flex-shrink: 0;
    font-family: Raleway, sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    text-wrap: nowrap;
    white-space: pre;

    @media (max-width: 1024px) {
      text-align: center;
    }

    @media (max-width: 767px) {
      white-space: normal;
    }
  }
`;

/**
 * Export `Footer` component.
 */

export function Footer() {
  const { t } = useTranslation('landingpage');

  return (
    <Container data-name={'Footer'} id={'footer'}>
      <div>
        <div>
          <div className={'logo'} data-name={'Logo Controlar'}>
            <div className={'clip-path'} data-name={'Clip path group'}>
              <div className={'group'} data-name={'Group'}>
                <FooterLogo />
              </div>
            </div>
          </div>

          <nav aria-label={'Links do rodapé'} data-name={'PPTTRT'}>
            <a href={'/legal/politica-de-privacidade'}>{t('footer.links.privacy')}</a>
            <a href={'/legal/politica-de-cookies'}>{t('footer.links.cookies')}</a>
            <a href={'/legal/termos-de-utilizacao-do-site'}>{t('footer.links.terms')}</a>
          </nav>

          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </Container>
  );
}
